import { FormControlLabel, FormGroup, Switch, SwitchProps } from "@mui/material";
import { useContext } from "react";
import { AppContext } from "../../common/contexts/app_context/app_context";

interface Props extends SwitchProps {
  label: string
}

function SwitchPrimary({ label, ...props }: Props) {
  const { theme } = useContext(AppContext)
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Switch
            sx={{
              color: "#009C4E",
              '& .MuiSwitch-switchBase': {
                '&.Mui-checked': {
                  color: '#009C4E',
                  '& + .MuiSwitch-track': {
                    backgroundColor: '#009C4E',
                  },
                },
              }
            }}
            {...props}
          />}
        sx={{ color: theme == "dark" ? "white" : "black" }}
        label={label} />
    </FormGroup>
  );
}

export default SwitchPrimary;